<script setup lang="ts">
import { toRefs } from 'vue';
import { BASE_URL } from '@/Constants';

const props = defineProps<{
  virtualRobotToken?: string;
  error?: string;
}>();

const { virtualRobotToken, error } = toRefs(props);
</script>
<template>
  <div class="robflow-container">
    <div v-if="error">{{ error }}</div>
    <iframe
      v-else-if="virtualRobotToken"
      class="iframe-layout"
      :src="`${BASE_URL}/virtual-robot/session/${virtualRobotToken}`"
      title="RobFlow Session"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>

<style lang="scss">
.robflow-container {
  width: 100%;
  height: 100%;
}
.iframe-layout {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
